import { render, staticRenderFns } from "./RouterViewGenerico.vue?vue&type=template&id=30e66830&scoped=true&"
import script from "./RouterViewGenerico.vue?vue&type=script&lang=ts&"
export * from "./RouterViewGenerico.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e66830",
  null
  
)

export default component.exports